import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
function Kitchen() {
  const hourRef = useRef(null);
  const minuteRef = useRef(null);
  const secondRef = useRef(null);
  const navigate = useNavigate();
  const [getRegisterEmployee, setRegisterEmployee] = useState([])
  const [getUPEmployee, setUpastitEmployee] = useState([])
  const [details, setDetails] = useState({
    totalemployee: 0,
    todayattendance: 0,
    kitchen_name: "",
  });
  const userid = localStorage.getItem("user_id");


  useEffect(() => {
    axios.get(`https://ims-attendanceback.indevconsultancy.in/api/show-details?kitchen_id=${userid}`)
      .then((response) => {
        setDetails(response.data);
      })
      .catch((error) => {
        console.error("Error fetching details:", error);
      });
  }, []);

  console.log('sds', getRegisterEmployee);
  const handleAttendanceClick = () => {
    navigate("/punch");
  };
  const calculateSpentTime = (entry, exit) => {
    const entryTime = new Date(entry);
    const exitTime = new Date(exit);
    const diffMs = exitTime - entryTime;
    const diffHrs = diffMs / (1000 * 60 * 60); // convert ms to hours
    const hours = Math.floor(diffHrs);
    const minutes = Math.floor((diffHrs % 1) * 60);

    return {
      totalHours: diffHrs,
      display: `${hours}h ${minutes}m`
    };
  };
  useEffect(() => {
    const updateClock = () => {
      const now = new Date();
      const second = now.getSeconds();
      const minute = now.getMinutes();
      const hour = now.getHours();

      const secondDeg = second * 6;
      const minuteDeg = minute * 6 + second * 0.1;
      const hourDeg = hour * 30 + minute * 0.5;

      secondRef.current.style.transform = `rotate(${secondDeg}deg)`;
      minuteRef.current.style.transform = `rotate(${minuteDeg}deg)`;
      hourRef.current.style.transform = `rotate(${hourDeg}deg)`;
    };

    const interval = setInterval(updateClock, 1000);
    updateClock();

    return () => clearInterval(interval);
  }, []);

  const handleClickTotalEmployee = () => {
    axios.get(`https://ims-attendanceback.indevconsultancy.in/api/register-employee?user_id=${userid}`)
      .then((response) => {
        setRegisterEmployee(response.data.employees);
      })
      .catch((error) => {
        console.error("Error fetching details:", error);
      });

  };

  const handleClickTotalUpEmployee = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months start at 0
    const dd = String(today.getDate()).padStart(2, '0');

    const currentDate = `${yyyy}-${mm}-${dd}`; // e.g., "2025-06-28"

    axios.get(`https://ims-attendanceback.indevconsultancy.in/api/attendance-detail-master/?user_id=${userid}&serchdate=${currentDate}`)
      .then((response) => {
        setUpastitEmployee(response.data);
      })
      .catch((error) => {
        console.error("Error fetching details:", error);
      });
  };

  const formatTime = (dt) =>
    dt.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

  console.log('ada', getUPEmployee)
  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-cream">
      <div className="container my-5">
        <div className="card shadow text-center">
          <div className="card-header fs-3 fw-semibold bg-skyBlue text-white">
            {userid === "8"
              ? "प्रधान कार्यालय में आपका स्वागत है"
              : details.kitchen_name === "2"
                ? `${details.kitchen_name} रसोई  में आपका स्वागत है`
                : `${details.kitchen_name} रसोई  में आपका स्वागत है`}
          </div>

          <div className="card-body bg-pink">
            <div className="row mb-4">
              <div className="col">
                {/* <h4>
                  कुल स्टाफ: <span className="badge bg-magenta ">{details.totalemployee}</span>
                </h4> */}
                <h4>
                  कुल स्टाफ:{" "}
                  <span
                    className="badge bg-magenta"
                    style={{ cursor: "pointer" }}
                    data-bs-toggle="modal"
                    data-bs-target="#totalEmployeeModal"
                    onClick={() => handleClickTotalEmployee()}

                  >
                    {details.totalemployee}
                  </span>
                </h4>
              </div>
              <div className="col">
                {/* <h4>
                  उपस्थिति दर्ज:{" "}
                  <span className="badge bg-orange">
                    {details.todayattendance}
                  </span>
                </h4> */}

                <h4>
                  उपस्थिति दर्ज:{" "}
                  <span
                    className="badge bg-orange"
                    style={{ cursor: "pointer" }}
                    data-bs-toggle="modal"
                    data-bs-target="#employeeAttendanceModal"
                    onClick={() => handleClickTotalUpEmployee()}

                  >
                    {details.todayattendance}
                  </span>
                </h4>
              </div>
            </div>

            {/* यथार्थवादी एनालॉग घड़ी */}
            <div className="mb-5 d-flex justify-content-center">
              <div className="clock-wrapper">
                <div className="clock-face">
                  <div ref={hourRef} className="hand hour-hand"></div>
                  <div ref={minuteRef} className="hand minute-hand"></div>
                  <div ref={secondRef} className="hand second-hand"></div>
                </div>
              </div>
            </div>

            <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-3">
              <div className="d-flex gap-2 flex-wrap justify-content-center">
                <button
                  type="button"
                  className="btn btn-primary bg-green px-4"
                  onClick={handleAttendanceClick}
                >
                  📝 उपस्थिति दर्ज करें
                </button>
                <button
                  type="button"
                  className="btn btn-warning text-white px-4"
                  onClick={() => navigate("/exit")}
                >
                  📝 प्रस्थान दर्ज करें
                </button>
                <button
                  type="button"
                  className="btn text-white px-4"
                  style={{ backgroundColor: "#0277bd" }}
                  onClick={() => navigate("/kitchen-leave-request")}
                >
                  🏖️ छुट्टी का अनुरोध
                </button>
              </div>
            </div>
          </div>

          <div className="card-footer text-muted small">
            तकनीकी साझेदार: Indev Consultancy ©2025
          </div>
        </div>
      </div>

      {/* Total Employee Modal */}
      <div
        className="modal fade"
        id="totalEmployeeModal"
        tabIndex="-1"
        aria-labelledby="employeeModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header bg-skyBlue text-white">
              <h5 className="modal-title" id="employeeModalLabel">
                Total Employees List
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">


              <div className="d-flex justify-content-start mb-3">
                <h6 className="mb-0">
                  Total Employees: <strong>{getRegisterEmployee.length}</strong>
                </h6>
              </div>

              {/* Table */}
              <div className="table-responsive" style={{ height: "300px" }}>
                <table className="table table-bordered table-striped text-center">
                  <thead className="table-light">
                    <tr>
                      <th>S.No.</th>
                      <th>Employee Code</th>
                      <th>Employee Name</th>
                      <th>Father's Name</th>
                      <th>Mobile Number</th>
                      <th>Date of Joining</th>
                      <th>Date of Exit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getRegisterEmployee.length > 0 ? (
                      getRegisterEmployee.map((emp, index) => (
                        <tr key={emp.id}>
                          <td>{index + 1}</td>
                          <td>{emp.employee_code}</td>
                          <td>{emp.emp_name}</td>
                          <td>{emp.father_name}</td>
                          <td>{emp.emp_mobile_no}</td>
                          <td>{emp.date_of_joining ? new Date(emp.date_of_joining).toLocaleDateString('en-IN') : '-'}</td>
                          <td>{emp.date_of_exiting ? new Date(emp.date_of_exiting).toLocaleDateString('en-IN') : '-'}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7">No records found</td>
                      </tr>
                    )}
                  </tbody>
                </table>

              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* employeeAttendanceModal  */}
      <div
        className="modal fade"
        id="employeeAttendanceModal"
        tabIndex="-1"
        aria-labelledby="employeeAttendanceModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header bg-skyBlue text-white">
              <h5 className="modal-title" id="employeeAttendanceModalLabel">
                Total Employee Present
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              <div className="d-flex justify-content-start mb-3">
                <h6 className="mb-0">
                  Total Employees: <strong>{getUPEmployee.length}</strong>
                </h6>
              </div>

              <div className="table-responsive" style={{ height: "300px" }}>
                <table className="table table-bordered table-striped text-center">
                  <thead className="table-light">
                    <tr>
                      <th>S.No</th>
                      <th>Employee Name</th>
                      <th>Employee Code</th>
                      <th>Entry Time</th>
                      <th>Exit Time</th>
                      <th>Time Spend</th>
                      <th>Entry Image</th>
                      <th>Exit Image</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getUPEmployee.length > 0 ? (
                      getUPEmployee.map((emp, index) => {
                        const spentTime =
                          emp.entry_time && emp.exit_time
                            ? calculateSpentTime(emp.entry_time, emp.exit_time)
                            : null;

                        return (
                          <tr key={emp.id || `emp-${index}`}>
                            <td>{index + 1}</td>
                            <td>{emp.emp_name}</td>
                            <td>{emp.emp_code}</td>
                            <td>{emp.entry_time ? formatTime(new Date(emp.entry_time)) : "-"}</td>
                            <td>{emp.exit_time ? formatTime(new Date(emp.exit_time)) : "-"}</td>
                            <td
                              style={{
                                color: spentTime
                                  ? spentTime.totalHours >= 8
                                    ? "green"
                                    : "red"
                                  : "inherit",
                              }}
                            >
                              {spentTime ? spentTime.display : "-"}
                            </td>
                            <td>
                              <img
                                src={emp.entryimage || "/default-entry.jpg"}
                                alt="Entry"
                                style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                loading="lazy"
                              />
                            </td>
                            <td>
                              <img
                                src={emp.exitimage || "/default-exit.jpg"}
                                alt="Exit"
                                style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                loading="lazy"
                              />
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        {/* fixed colSpan from 7 → 8 to match total columns */}
                        <td colSpan="8" className="text-muted text-center">
                          No records found
                        </td>
                      </tr>
                    )}
                  </tbody>

                </table>
              </div>

            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* यथार्थवादी घड़ी के स्टाइल्स */}
      <style>{`
.clock-wrapper {
  width: 200px;
  height: 200px;
  border: 8px solid #343a40;
  border-radius: 50%;
  position: relative;
  background: white;
  box-shadow: inset 0 0 15px #ddd;
}

.clock-face {
  width: 100%;
  height: 100%;
  position: relative;
}

.hand {
  position: absolute;
  bottom: 50%;
  left: 50%;
  transform-origin: bottom center;
  transform: rotate(90deg);
}

.hour-hand {
  width: 5px;
  height: 50px;
  background: #000;
  z-index: 3;
}

.minute-hand {
  width: 3px;
  height: 70px;
  background: #0277bd;
  z-index: 2;
}

.second-hand {
  width: 2px;
  height: 90px;
  background: #ff8f00;
  z-index: 1;
}
      `}</style>
    </div>
  );
}

export default Kitchen;
